import { withLocalState } from 'pyradux';

import Container from './ClientNotes.container';
import reducer from './ClientNotes.reducer';
import Sagas from './ClientNotes.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'clientNotes',
  sagas: [Sagas],
};

export default withLocalState(withLocalStateOptions, Container);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/ClientModal/ClientNotes/index.js